import { useState } from "react";

import IntentSignalsEventsTooltipContainer from "app/pages/sales-intelligence/pages/company-analysis/components/signals/SignalEventInfo/IntentSignalEventInfo/IntentSignalsEventsTooltip/IntentSignalsEventsTooltipContainer";
import IntentSignalsEventsTooltipContent from "app/pages/sales-intelligence/pages/company-analysis/components/signals/SignalEventInfo/IntentSignalEventInfo/IntentSignalsEventsTooltip/IntentSignalsEventsTooltipContent";
import type { IntentCountryScopeDto } from "app/pages/sales-intelligence/modules/company-analysis/types/signals";
import CollapsibleSection from "app/pages/sales-intelligence/pages/company-analysis/components/shared/section/CollapsibleSection/CollapsibleSection";
import CollapsibleTrigger from "app/pages/sales-intelligence/pages/company-analysis/components/shared/section/CollapsibleTrigger/CollapsibleTrigger";

type Props = {
    domains: readonly { domain: string; countriesScopes: readonly IntentCountryScopeDto[] }[];
};

const IntentSignalDomainsEventTooltipBox = ({ domains }: Props) => {
    const [openSection, setOpenSection] = useState(() => domains?.[0]?.domain ?? "");

    return (
        <IntentSignalsEventsTooltipContainer>
            {domains.map(({ domain, countriesScopes }) => (
                <CollapsibleSection
                    key={domain}
                    id={domain}
                    externalIsExpanded={openSection === domain}
                    onToggle={() => {
                        setOpenSection(openSection === domain ? "" : domain);
                    }}
                    renderTrigger={(props) => <CollapsibleTrigger {...props}>{domain}</CollapsibleTrigger>}
                >
                    <IntentSignalsEventsTooltipContent countries={countriesScopes} />
                </CollapsibleSection>
            ))}
        </IntentSignalsEventsTooltipContainer>
    );
};

export default IntentSignalDomainsEventTooltipBox;
